var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('narrative-filter',{attrs:{"user-list":_vm.userList},on:{"user-changed":function($event){return _vm.onUserChanged($event)}}}),_c('narrative-list',{attrs:{"filter-user":_vm.user},on:{"update-list":_vm.updateList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }